import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-welltect-unblock',
  templateUrl: './welltect-unblock.component.html',
  styleUrls: ['./welltect-unblock.component.css', '../style/global.css'],
})
export class WelltectUnblockComponent implements OnInit {
  countdown = 10;
  initialize = false;
  @Input()
  clientId: string;
  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.initialize = true;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.redirect();
          clearInterval(interval);
        }
      }, 1000);
    }, 1000);
  }

  redirect() {
    location.href = environment.apps[this.clientId].appUrl;
  }

  get logoUrl() {
    return (
      environment.apps[this.clientId].oemConfig?.imgpath ||
      '/assets/welltect/images/logo.svg'
    );
  }

  get appname() {
    return environment.apps[this.clientId].oemConfig?.name || 'Doctors Station';
  }
}
